import React, { PropTypes } from "react";

const ConvertibleDescription = ({ size }) => {
  return (
    <div>
      <table className="car-seat-description">
        <tbody>
          <tr><th>Rear Facing:&nbsp;</th><td>{size.rearFacingHeight}</td></tr>
          <tr><td></td><td>{size.rearFacingWeight}</td></tr>
        </tbody>
      </table>
      <table className="car-seat-description">
        <tbody>
          <tr><th>Front Facing:&nbsp;</th><td>{size.frontFacingHeight}</td></tr>
          <tr><td></td><td>{size.frontFacingWeight}</td></tr>
        </tbody>
      </table>
    </div>
  );
};

ConvertibleDescription.propTypes = {
  size: PropTypes.object.isRequired,
};

export default ConvertibleDescription;


/** WEBPACK FOOTER **
 ** ./src/components/AvailableSizes/CarSeatsContainer/Descriptions/ConvertibleDescription.js
 **/